import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Import global data service
import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { DatabindingService } from 'src/app/Services/Databinding/databinding.service';

@Component({
  selector: 'app-bulk-invite',
  templateUrl: './bulk-invite.component.html',
  styleUrls: ['./bulk-invite.component.css']
})
export class BulkInviteComponent implements OnInit {
  uploadCSVModal: boolean = false;
  isChecked: boolean = false;
  // records
  records: any = [];
  recordsloadLimit = 500;
  recordsTotal = 0;
  currentPage = 1;
  filterConditions = [];

  // user login
  login: boolean = false;
  user_data: any;

  // Loading
  loading: Loading;

  // error
  error_messages: any = [];

  // Data
  data: any = [];
  salesforce: any = [];
  record_list: any = [];
  bulk_invite_type: string = '';
  is_view_next: boolean;
  record_count: Number;
  recentRecords: any = [];

  bad_template_setting: boolean = false;

  salesforce_session_data: any;

  recordFieldsMeta: any = [];

  pager: any = {};

  constructor(
    private router: Router,
    private dataService: DataService,
    private databindingService: DatabindingService
  ) {
    this.loading = dataService.getLoading();
  }

  ngOnInit() {
    this.updateLoading(true, '');
    this.loadSalesforceDataAndUpdateUserDB();
    this.dataService.resetData();
    this.dataService.setRecordList([]);

    this.loadInfo();
    this.getSfObjectMeta(this.dataService.getUrlParamater('bulk_invite_type'));
  }

  getSfObjectMeta(objectTypeStr) {
    this.databindingService.getSalesforceObjectMetadata(objectTypeStr).subscribe(
      (result) => {
        this.recordFieldsMeta = result || [];
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  async loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
    this.record_list = this.dataService.getDocumentGroup();

    // load view

    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      this.records = [];
      this.login = true;
      return;
    }
    const view = this.salesforce_session_data.view;
    const page_view = this.dataService.getUrlParamater('view').toLowerCase();
    this.bulk_invite_type = this.dataService.getUrlParamater('bulk_invite_type');
    const template_setting_id = this.dataService.getUrlParamater('template_setting');
    await this.check_if_valid_template_setting(template_setting_id);
    if (this.bulk_invite_type === '') {
      this.updateError(
        `Error loading the record type. Please make sure that 'bulk_invite_type' URL button parameter is set correctly.`
      );
    }
    this.dataService.setOriginView(page_view || view);
  }

  resetPaginator() {
    this.pager = {};
    this.dataService.setRecordList([]);
    this.record_count = 0;
    this.currentPage = 0;
  }

  reloadAfterSSOLogin() {
    this.login = false;
    this.reload();
  }

  reload() {
    this.isChecked = false;
    this.is_view_next = false;
    this.recentRecords = [];

    this.recordsTotal = 0;
    this.filterConditions = [];
    this.resetPaginator();
    this.loadSalesforceDataAndUpdateUserDB();

    this.dataService.setRecordList([]);
    this.dataService.resetData();
    this.updateLoading(true, '');
    this.loadInfo();
  }

  async loadSalesforceDataAndUpdateUserDB() {
    try {
      this.salesforce_session_data = await this.dataService.getSalesforceData();

      if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
        this.updateLoading(false, '');
        this.updateError(this.dataService.salesforce_session_error);
        this.records = [];
        this.login = true;
        return;
      }

      const sf_user_id = this.salesforce_session_data.sf_user_id;

      // send information to db: user will be added if not already found in db otherwise user data will be updated
      this.user_data = {
        sf_user_id: this.salesforce_session_data.sf_user_id,
        sn_token: '',
        sn_refresh: '',
        sf_org_id: this.salesforce_session_data.sf_org_id,
        sf_token: this.salesforce_session_data.sf_token,
        sf_refresh: this.salesforce_session_data.sf_refresh,
        instance_url: this.salesforce_session_data.instance_url
      };
      this.updateLoading(true, `Checking validity of user's token.`);
      this.dataService
        .apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id)

        .subscribe((result) => {
          if (!(result.in_db && result.valid_sn_token)) {
            // login before continuing
            this.updateLoading(false, '');
            this.records = [];
            this.login = true; // this variable makes the login div visible
          } else {
            // ;
            //////////////////////////// user data has all the information needed to connect to SignNow ///////////////////////////////
            const sn_token = result.sn_token;
            const sn_refresh = result.sn_refresh;
            this.user_data.sn_token = sn_token;
            this.user_data.sn_refresh = sn_refresh;
            this.dataService.setSignNowOwnerEmail(result.sn_email);
            /*
              Load record List
            */
            this.loadRecordList();
            //////////////////////////////// update user db /////////////////////////////////////////////////////////////////////////////
            if (this.user_data.sn_token) {
              this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
            }
          }
        });
    } catch {}
  }

  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  loadRecordList() {
    // this.loadRecordsFromSf('/api/get_record_list');
    this.loadRecordsFromSf();
  }

  loadFilteredRecordsList($event) {
    this.resetPaginator();
    this.filterConditions = $event.conditionsList;
    this.loadRecordsFromSf(this.filterConditions);
  }

  /**
   *
   * @param endpointString = '/api/get_filtered_records'
   */
  private loadRecordsFromSf(conditions = this.filterConditions) {
    this.clearErrors();
    this.updateLoading(true, 'Loading records list.');
    this.isChecked = false;
    this.is_view_next = false;
    this.dataService.setRecordList([]);

    const salesforce_data = this.dataService.getSalesforceData();
    const email_field_name = this.dataService.getUrlParamater('bulk_email_field') || ' Email';
    const offset = (this.currentPage > 0 ? this.currentPage - 1 : 0) * this.recordsloadLimit;

    const data = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      record_name: this.bulk_invite_type,
      email_field: email_field_name,
      conditions: conditions,
      load_limit: this.recordsloadLimit,
      offset: offset
    };

    this.dataService
      .apiPostCall('/api/get_filtered_records', data)

      .subscribe(
        (result) => {
          const valid_records = [];
          let valid_count = 0;

          for (let i = 0; i < result.records.length; i++) {
            const email_value = this.getProperty(result.records[i], email_field_name);
            if (this.validateEmail(email_value) === true && email_value) {
              valid_records[valid_count] = {
                Id: result.records[i].Id,
                Name: result.records[i].Name,
                Email: email_value,
                CreatedDate: result.records[i].CreatedDate
              };
              valid_count++;
            }
          }

          this.records = valid_records;
          this.recordsTotal = result.total;

          if (this.recentRecords.length === 0) {
            this.recentRecords = valid_records;
          }

          if (!this.pager.inited) {
            this.initPaginator(1, this.recordsTotal);
          }

          this.updateLoading(false, '');
        },
        (error) => {
          this.updateLoading(false, '');
          this.updateError(error.error);
        }
      );
  }

  getProperty(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return '';
      }
    }
    return o;
  }

  async check_if_valid_template_setting(template_setting_id) {
    if (template_setting_id.length > 1) {
      try {
        const result: any = await this.getTemplateSetting(template_setting_id);
        if (result.isError === true) {
          this.updateError(result.message);
          this.bad_template_setting = true;
        }
      } catch {}
    }
  }

  getTemplateSetting(template_setting_id) {
    return new Promise((resolve) => {
      // this.updateLoading(true, "Loading template settings data.");
      const ignore_type = this.bulk_invite_type;
      const data = {
        sf_token: this.salesforce.sf_token,
        instance_url: this.salesforce.instance_url,
        template_setting_id: template_setting_id,
        record_id: this.salesforce.record_id,
        ignore_type: ignore_type
      };

      this.dataService
        .apiPostCall('/api/get_template_setting_ignore', data)

        .subscribe(
          (result) => {
            resolve(result);
          },
          (error) => {
            this.bad_template_setting = true;
            if (error.status === 504) {
              this.updateError('Failed to load template setting.');
              this.updateLoading(false, '');
            } else {
              this.updateError(error.error);
              this.updateLoading(false, '');
            }
          }
        );
    });
  }

  go_to_template_list() {
    if (this.bad_template_setting === false) {
      // post_record_to_signnow
      this.router.navigate(['bulk_invite_template']);
    } else {
      this.updateError(
        'Before proceeding to the next step, please make sure the template setting is correct.'
      );
    }
  }

  logout_user() {
    this.updateLoading(true, 'logging out user!');
    this.user_data.sn_token = '';
    this.user_data.sn_refresh = '';
    this.user_data.sn_email = '';

    this.dataService
      .apiPostCall('/api/update_user_db', JSON.stringify(this.user_data))

      .subscribe(() => {
        this.updateLoading(false, '');
        this.records = [];
        this.login = true;
      });
  }

  login_user(email, password) {
    // when login div button is submitted we login to SignNow
    const login_data = {
      username: email,
      password: password
    };

    this.updateLoading(true, 'Requesting to login with SignNow.');
    this.dataService
      .apiPostCall('/api/login_to_signnow', JSON.stringify(login_data))

      .subscribe((result) => {
        this.updateLoading(true, 'Login with SignNow response returned.');
        if (result.valid_credentials == true) {
          this.clearErrors();
          const sn_token = result.sn_token;
          const sn_refresh = result.sn_refresh;

          this.login = false;
          this.user_data.sn_token = sn_token;
          this.user_data.sn_refresh = sn_refresh;
          this.user_data.sn_email = email;
          this.dataService.setSignNowOwnerEmail(email);

          this.updateLoading(
            true,
            'Validating SignNow login credentials and updating user data on this account.'
          );
          this.dataService
            .apiPostCall('/api/update_user_db', JSON.stringify(this.user_data))

            .subscribe(() => {
              this.updateLoading(false, '');
              this.reload();
            });
        } else {
          this.updateLoading(false, '');
          this.updateError(
            'Invalid user credentials. Please enter valid user credentials to log in to SignNow.'
          );
        }
      });
  }

  clearErrors() {
    this.error_messages = [];
  }
  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }
  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }
  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message === this.error_messages[i]) {
        this.error_messages.splice(i, 1);
      }
    }
  }

  addToRecordList(record, event) {
    if (event.target.checked) {
      this.dataService.addToRecordList(record);
      this.record_count = this.dataService.getRecordList().length;
      // console.log('Total # of Documents in Group: ' + this.record_list_count);
    } else {
      this.dataService.removeFromRecordList(record);
      this.record_count = this.dataService.getRecordList().length;
    }

    this.is_view_next = this.record_count >= 1;
  }

  close_modal() {
    this.uploadCSVModal = false;
  }

  open_modal() {
    this.uploadCSVModal = true;
  }

  loadRecordList_from_file(record_id_list) {
    return new Promise((resolve, reject) => {
      this.close_modal();
      this.updateLoading(true, 'Loading records in the file from Salesforce.');
      const salesforce_data = this.dataService.getSalesforceData();
      let email_field = this.dataService.getUrlParamater('bulk_email_field');

      if (email_field === '' || !email_field) {
        email_field = 'Email';
      } else {
        email_field = this.dataService.getUrlParamater('bulk_email_field');
      }

      const data = {
        sf_token: salesforce_data.sf_token,
        instance_url: salesforce_data.instance_url,
        record_name: this.bulk_invite_type,
        email_field: email_field,
        record_id_list: record_id_list
      };

      this.dataService
        .apiPostCall('/api/get_record_list_given_ids', data)

        .subscribe(
          (result) => {
            const email_name = this.dataService.getUrlParamater('bulk_email_field');
            const valid_records = [];
            let valid_count = 0;

            for (let i = 0; i < result.length; i++) {
              const email_value = this.getProperty(result[i], email_name);
              if (email_value && this.validateEmail(email_value) === true) {
                valid_records[valid_count] = {
                  Id: result[i].Id,
                  Name: result[i].Name,
                  Email: email_value,
                  CreatedDate: result[i].CreatedDate
                };
                valid_count++;
              }
            }
            this.records = valid_records;

            this.updateLoading(false, '');
            resolve('done');
          },
          () => {
            this.clearErrors();
            this.updateLoading(false, '');
            this.updateError(
              'An error occurred uploading the CSV. Please make sure that the document is a CSV list of IDs separated by new lines between each ID.'
            );
            reject();
          }
        );
    });
  }

  checkAll() {
    this.isChecked = true;
    this.records.forEach(function (item) {
      item.selected = true;
      // console.log(item);
    });
  }

  checkItem(event) {
    if (event.target.checked) {
      this.isChecked = true;
      this.records.forEach(function (item) {
        item.selected = true;
        // console.log(item);
      });

      for (let i = 0; i < this.records.length; i++) {
        this.dataService.addToRecordList(this.records[i]);
        this.record_count = this.dataService.getRecordList().length;
      }
    } else {
      this.isChecked = false;
      this.records.forEach(function (item) {
        item.selected = false;
      });

      for (let i = 0; i < this.records.length; i++) {
        this.dataService.removeFromRecordList(this.records[i]);
        this.record_count = this.dataService.getRecordList().length;
      }
    }

    this.is_view_next = this.record_count >= 1;
  }

  async readFile(event) {
    const file = event.srcElement.files[0];
    const result = await this.loadFile(file);
    const record_id_list = result.toString().split(/\r?\n/);

    this.dataService.setRecordList([]);
    await this.loadRecordList_from_file(record_id_list);
    this.checkAll();

    // add records to record list and show the next button to go into the templates page
    for (let i = 0; i < this.records.length; i++) {
      this.dataService.addToRecordList(this.records[i]);
      this.record_count = this.dataService.getRecordList().length;
    }

    this.is_view_next = this.record_count >= 1;
  }

  loadFile(file) {
    return new Promise((resolve) => {
      const fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result);
      };
      fr.readAsText(file);
    });
  }

  search_records(value) {
    // Declare variables
    let input, filter, table, tr, td, td2, i;
    input = value;
    filter = input.toUpperCase();
    table = document.getElementById('RecordTable');
    tr = table.getElementsByTagName('tr');

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName('td')[0];
      td2 = tr[i].getElementsByTagName('td')[1];

      if (td || td2) {
        if (
          td.innerText.toUpperCase().indexOf(filter) > -1 ||
          td2.innerText.toUpperCase().indexOf(filter) > -1
        ) {
          tr[i].style.display = '';
        } else {
          tr[i].style.display = 'none';
        }
      }
    }
  }

  setPage(page: number) {
    let currentPage = page;

    if (page < 1) {
      currentPage = 1;
    } else if (page > this.pager.totalPages) {
      currentPage = this.pager.totalPages;
    }

    this.currentPage = this.pager.currentPage = currentPage;
    this.loadRecordsFromSf(this.filterConditions);
  }

  initPaginator(currentPage: number = 1, totalItems: number, pageSize: number = this.recordsloadLimit) {
    // calculate total pages
    const totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    // return object with all pager properties required by the view
    this.pager = {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      inited: true
    };
  }
}
